import React, { useEffect, useState } from 'react';
import { UserRound, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import { getLinkedProfiles } from '../lib/api';

// Pulsanti "Profilo N" per gli ALTRI profili del gruppo. Nascosto per admin, impersonazione o senza gruppo.
export const LinkedProfilesSwitcher = ({ hidden = false, compact = false, accentColor = '#26A17B' }) => {
  const { user, isAdmin, switchProfile } = useAuth();
  const [profiles, setProfiles] = useState([]);
  const [switchingTo, setSwitchingTo] = useState(null);

  const groupId = user?.profile_group_id;

  useEffect(() => {
    if (!groupId || isAdmin || hidden) { setProfiles([]); return; }
    getLinkedProfiles()
      .then(res => setProfiles(res.data.profiles || []))
      .catch(() => setProfiles([]));
  }, [groupId, isAdmin, hidden]);

  if (hidden || isAdmin || !groupId || profiles.length === 0) return null;

  const handleSwitch = async (p) => {
    setSwitchingTo(p.user_id);
    try {
      await switchProfile(p.user_id);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Cambio profilo non riuscito');
      setSwitchingTo(null);
    }
  };

  return (
    <div className={compact ? 'px-4 pb-2' : 'mb-2'} data-testid="linked-profiles-switcher">
      {!compact && (
        <p className="text-[10px] uppercase tracking-wider text-disabled px-2 mb-1">
          Sei in {user?.profile_label || 'Profilo'}
        </p>
      )}
      <div className={compact ? 'flex gap-2 overflow-x-auto' : 'flex flex-wrap gap-1.5 px-2'}>
        {profiles.map(p => (
          <button
            key={p.user_id}
            onClick={() => handleSwitch(p)}
            disabled={!!switchingTo}
            title={p.name}
            data-testid={`switch-profile-btn-${p.profile_index}`}
            className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border transition-colors disabled:opacity-60 whitespace-nowrap hover:bg-gray-800"
            style={{ borderColor: `${accentColor}66`, color: accentColor }}
          >
            {switchingTo === p.user_id ? <Loader2 size={12} className="animate-spin" /> : <UserRound size={12} />}
            {p.profile_label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LinkedProfilesSwitcher;
